import(/* webpackMode: "eager" */ "/vercel/path0/app/(onboarding)/layout.js");
